import { Component, Input } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { UserService } from 'src/app/Core/services/user.service';
import { ToasterService } from 'src/app/Core/services/toaster.service';
import { HttpErrorResponse } from '@angular/common/http';

interface Subscriptions {
  subscriptionState: string,
  expiryTime: string,
  biller: string,
  product_id: string,
  event_time: string,
  userInitiatedCancellation: Data,
  startTime: string,
  notificationType: string,
  productId: string,
  originalTransactionId: string,
  transactionId: string,
  eventTime: string,
  regionCode: string,
  currencyCode: string,
  units: string,
}

interface Location {
  id: string;
  label: string;
}

interface Device {
  serialnumber: string;
  id: string;
  location: Location;
  model: string;
  announcement: string;
  label: string;
  status: string;
}

@Component({
  selector: 'app-iaq-subscriptions',
  templateUrl: './iaq-subscriptions.component.html',
  styleUrls: ['./iaq-subscriptions.component.css']
})

export class IaqSubscriptionsComponent {
  iaqDisplayToggle: boolean = true;
  userID: string = '';
  subscriptionsHistory: Subscriptions[] = [];
  devices: Device[] = [];
  numberOfDeferDays: string;
  selectedDeferReason: string;
  dateFormat: string = 'dd MMM yyyy hh:mm:ss a';

  constructor(private route: ActivatedRoute, private userService: UserService, private toaster: ToasterService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.userID = params.get('id') || '';
      this.fetchUserSubscriptionsHistory();
    });
  }

  fetchUserSubscriptionsHistory(): void {
    this.userService.getSubscriptionsHistory(this.userID).subscribe({
      next: (data) => {
        console.log('Subscriptions History:', data);
        this.subscriptionsHistory = data;
      },
      error: (error) => {
        console.error('Failed to fetch subscriptions history', error);
        if (error instanceof HttpErrorResponse) {
          if (error.status === 403) {
            this.toaster.openDialogBox("You are unauthorized to access this page", true);
          } else {
            this.toaster.openDialogBox(error.error.message, false);
          }
        }
      }
    });
  }

  getDeviceStatus(contactLost: boolean): string {
    return contactLost ? 'INACTIVE' : 'ACTIVE';
  }

  capitalizeFirstLetter(str: string | null | undefined): string {
    if (!str) {
      return '';
    }
    const capitalizedStr = str.charAt(0).toUpperCase() + str.slice(1);
    return capitalizedStr.replace(/_/g, ' ');
  }

  get timezoneOffset(): string {
  const offset = new Date().getTimezoneOffset(); // in minutes
  const absOffset = Math.abs(offset);
  const hours = String(Math.floor(absOffset / 60)).padStart(2, '0');
  const minutes = String(absOffset % 60).padStart(2, '0');
  const sign = offset <= 0 ? '+' : '-';
  return `GMT${sign}${hours}:${minutes}`;
}
}
